var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default mb-3",on:{"click":_vm.refresh}},[_vm._v("Refresh")])}
var staticRenderFns = []

export { render, staticRenderFns }